import React from 'react';
import Chart from 'react-apexcharts';

const ExecutivePieChart = ({
    series,
    type,
    height,
    colors,
    labels,
}) => {
    const loadProfilePie = {
        chart: {
            type: 'pie',
        },
        colors: colors,
        labels: labels,
        legend: {
            show: false
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => Math.round(val) + '%',
            style: {
                fontSize: '10px',
                colors: ['#fff']
            }
        }
    };
    return (
        <Chart
            options={loadProfilePie}
            series={series}
            type="pie"
            height={height}

        />
    );
};

 


export {ExecutivePieChart}